var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CampaignSetupsSummaryModal',{ref:"campaignSetupsSummaryModal"}),_c('CampaignSetupsListTable',{attrs:{"filteredCampaignSetups":_vm.filteredCampaignSetups},on:{"viewSummary":_vm.viewSummary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }